<div class="action-arrow__content" (click)="stopPropagation($event)">
	<cv-switch
		[class]="'cv-switch-blue'"
		[size]="'sm'"
		[checked]="cellValue.isRead"
		(valueChange)="markReadUnread($event)"
	></cv-switch>
</div>
